import {
  GET_FOREIGN_TRAVEL_REQUEST,
  GET_FOREIGN_TRAVEL_SUCCESS,
  GET_FOREIGN_TRAVEL_FAIL,
  UPDATE_FOREIGN_TRAVEL_STATUS,
} from "../constants/foreignTravelConstants";
import ForeignTravelService from "../service/ForeignTravelService";

export const getForeignTravelDetails = () => async (dispatch) => {
  dispatch({ type: GET_FOREIGN_TRAVEL_REQUEST });

  try {
    const response = await ForeignTravelService.getForeignTravelDetails();
    const resultSet = response.data?.ResultSet || [];

    dispatch({
      type: GET_FOREIGN_TRAVEL_SUCCESS,
      payload: resultSet,
    });
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch foreign travel details";

    dispatch({
      type: GET_FOREIGN_TRAVEL_FAIL,
      payload: message,
    });
  }
};

export const updateForeignTravelRequestStatus = (updatedRequest) => (dispatch) => {
  dispatch({
    type: UPDATE_FOREIGN_TRAVEL_STATUS,
    payload: updatedRequest,
  });
};
